var isDev = /localhost:56\d{2}/.test(location.href);
var isSITUAT = location.href.indexOf("-sit") !== -1 || location.href.indexOf("-uat") !== -1;

const renderTutorials = () => {
  $(".help-more-container__content").append(
    `<h5>${$(`.help-more-container .help-more-container__tab p[data-hash="${location.hash.slice(1)}"]`).text()}</h5>
     <div class="help-more-container__list" />
    `
  );

  $(".help-more-container__list").append(
    window.faqGuideList.reduce((accTutorial, { imagePath, videoUrl, title, type }) => {
      if (location.hash.slice(1) && location.hash.slice(1) !== type.toString()) {
        return accTutorial;
      }

      return [
        ...accTutorial,
        `<div class="tutorial-container">
            <div class="tutorial-container__image-wrapper">
              <a href=${videoUrl} target="_blank">
                <img src=${imagePath} />
                <div class="tutorial-container__image-wrapper--overlay">
                  <img src="img/play.png" />
                </div>
              </a>
            </div>
            <p>${title}</p>
         </div>
        `,
      ];
    }, [])
  );
};

const getFaqGuideList = () => {
  $.ajax({
    type: "GET",
    url: `${isDev ? "/api" : ""}/web/rest/faqs/getFaqGuideList`,
    error: function () {},
  }).done(({ result }) => {
    window.faqGuideList = result;
    renderTutorials();
  });
};

const getFaqGuideType = () => {
  $.ajax({
    type: "GET",
    url: `${isDev ? "/api" : ""}/web/rest/faqs/getFaqGuideType`,
    error: function () {},
  }).done(({ result }) => {
    $(".help-more-container__tab").append(
      Object.entries(result).reduce(
        (accTutorialType, [typeId, typeName]) => {
          return [...accTutorialType, `<p data-hash="${typeId}">${typeName}</p>`];
        },
        [`<p data-hash="">全部</p>`]
      )
    );

    $(`.help-more-container .help-more-container__tab p[data-hash="${location.hash.slice(1)}"]`).addClass("active");

    $(".help-more-container .help-more-container__tab p").on("click", function () {
      location.hash = $(this).attr("data-hash") || "";

      $(".help-more-container .help-more-container__tab p").removeClass("active");
      $(this).addClass("active");

      $(".help-more-container__content").children().remove();
      $("html").scrollTop(0);
      renderTutorials();
    });
  });
};

$(function () {
  const path = location.pathname.split("/").pop();

  if (path === "help-more-tutorial.html") {
    getFaqGuideType();
    getFaqGuideList();
  }
});

$(".help-more-container .help-more-container__tab .tab-header").on("click", function () {
  location.href = "./help.html";
});
